import React from 'react';

const BstiSection = () => {
  return (
    <section className="bg-green-50 py-12 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex justify-center mb-8 md:mb-12 w-full px-2 max-w-2xl mx-auto">
          <div className="relative px-4 py-3 sm:px-6 sm:py-4 md:px-10 md:py-6 bg-white rounded-2xl shadow-sm border border-green-200 flex items-center justify-center w-full">
            <div className="relative flex flex-row items-center justify-center gap-3 md:gap-5 w-full">
               <div className="bg-green-50 p-2 md:p-3 rounded-full border border-green-100 shrink-0">
                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 sm:h-7 sm:w-7 md:h-10 md:w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                 </svg>
               </div>
               <h2 className="text-[13px] min-[375px]:text-[15px] sm:text-lg md:text-2xl font-bold text-gray-800 tracking-wide text-left md:text-center leading-snug">
                 বি এস টি আই <span className="text-green-600 md:text-transparent md:bg-clip-text md:bg-gradient-to-r from-green-600 to-emerald-600">লাইসেন্স নম্বর:</span> <span className="text-green-700 font-black tracking-tight ml-1 block sm:inline">CUM-Mr 0356</span>
               </h2>
            </div>
          </div>
        </div>
        
        <div className="mb-6">
          <img 
            src="/images/bsti-certificate.jpg" 
            alt="BSTI Certificate" 
            className="max-w-[280px] sm:max-w-sm w-full mx-auto rounded-xl shadow-xl border border-gray-100"
          />
        </div>
        
        <p className="text-gray-600 font-medium text-sm sm:text-base px-2">
          আমাদের পণ্য সরকার অনুমোদিত এবং সম্পূর্ণ নিরাপদ
        </p>
      </div>
    </section>
  );
};

export default BstiSection;
